export default __webpack_public_path__ + "static/media/send.d79e4c37.svg";